import React from 'react';
import { HOTEL_SEARCHBOX_CONFIG } from '@/config';
import { PrebookHotelSummaryModel } from '@/__generated';

type Props = {
  bookingSummary: PrebookHotelSummaryModel;
};

export default function ReadOnlyGuestNumber({ bookingSummary }: Props) {
  return (
    <div className="row x-gap-10 y-gap-20  mt-20">
      <div className="col-12  ">
        <div className="d-flex align-items-center">
          <div className="fw-bold text-18 text-blue-1  rounded-2 pr-10 text-uppercase">NUMBER OF GUESTS</div>
          <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
        </div>
      </div>
      <div className="mt-20 ">
        <div className="row x-gap-10 y-gap-20 fw-500 mb-10 bg-blue-2 rounded">
          <div className="col-md-3 col-2 sm-col-2 fw-500 text-14 text-center">Room</div>
          <div className="col-md-3 col-5 sm-col-5 fw-500 text-14  text-center">Adults(Male)</div>
          <div className="col-md-3 col-5 sm-col-5 fw-500 text-14  text-center">Adults(Female)</div>
          <div className="col-md-3 sm:d-none fw-500 text-14 text-center">{`Children(${HOTEL_SEARCHBOX_CONFIG.childrenMinAge}-${HOTEL_SEARCHBOX_CONFIG.childrenMaxAge})`}</div>
        </div>
        {bookingSummary.rooms?.map(room => {
          const noOfAdult = room.noOfAdult || 0;
          var maleCount = bookingSummary.passengerGenders?.find(x => x.roomIndex === room.roomIndex)?.maleCount || 0;

          return (
            <div className="row x-gap-10 y-gap-10 text-14 ">
              <div className="col-md-3 col-2 sm-col-2 text-center fw-500">{`Room #${room.roomIndex + 1}`}</div>
              <div className="col-md-3 col-5 sm-col-5 text-center px-20">
                <b>{maleCount} person</b>
              </div>
              <div className="col-md-3 col-5 sm-col-5 text-center px-20">
                <b>{noOfAdult - maleCount} person</b>
              </div>
              <div className="col-md-3 sm:d-none text-center fw-500">{`${room.noOfChild} children`}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
